const LINE_PROPERTY = "_is_bundle"
const LINE_PROPERTY_VALUE = "Yes"

const htmlParse = text => {
    const parser = new DOMParser()
    const htmlDoc = parser.parseFromString(text, "text/html")
    return htmlDoc.body
}
const addNewItemToCart = async ({ variant_id, quantity, properties = {} }) => {
    const formData = {
        items: [],
    }
    try {
        formData.items.push({
            id: variant_id,
            quantity: quantity,
            properties: properties,
        })
        const responseFetch = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        })
            .then(res => res.json())
            .catch(res => res.json())

        if (responseFetch.items.length > 0) {
            return true
        }
        return true
    } catch (e) {
        return false
    }
}

const addNewItemsToCart = async items => {
    if (!items.length) return false
    const formData = {
        items: [],
    }
    try {
        formData.items.push(
            ...items.map(item => {
                const properties = {}
                Object.keys(item.properties).forEach(key => {
                    if (key !== LINE_PROPERTY) {
                        properties[key] = item.properties[key]
                    } else {
                        properties[key] = null
                    }
                })
                return {
                    id: item.id,
                    quantity: item.quantity - 1 || 1,
                    properties: properties,
                }
            }),
        )
        const responseFetch = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        })
            .then(res => res.json())
            .catch(res => res.json())

        if (responseFetch.items.length > 0) {
            return true
        }
        return true
    } catch (e) {
        return false
    }
}

const checkCart = async () => {
    const cart = await fetch("/cart.js").then(res => res.json())
    const cartItems = cart.items.reverse()
    const bundleItems = cartItems.filter(item => item.properties[LINE_PROPERTY])
    const allowedBundles = []
    const removeAttrItems = []
    const restoreItems = []
    bundleItems.forEach(item => {
        if (!item.properties[LINE_PROPERTY]) {
            return
        }
        if (allowedBundles.some(allowedBundle => allowedBundle.product_id === item.product_id)) {
            removeAttrItems.push(item)
        } else {
            allowedBundles.push(item)
        }
    })

    cartItems.forEach(item => {
        if (item.properties[LINE_PROPERTY] !== null) {
            return
        }
        console.log("item", item)
        if (
            !allowedBundles.some(allowedBundle => allowedBundle.product_id === item.product_id) &&
            !restoreItems.some(restoreItem => restoreItem.product_id === item.product_id)
        ) {
            restoreItems.push(item)
        }
    })

    const updateItems = []
    allowedBundles.forEach(item => {
        if (item.quantity > 1) {
            updateItems.push(item)
        }
    })

    const responseUpdate = await updateCartItems(updateItems)
    const responseChange = await changeCartItems(removeAttrItems)
    const responseAllow = await changeCartItems(restoreItems, "Yes")
    const responseAdd = await addNewItemsToCart(updateItems)

    console.log("responseUpdate", responseUpdate)
    console.log("responseChange", responseChange)
    console.log("responseAllow", responseAllow)
    console.log("responseAdd", responseAdd)
    if (responseUpdate || responseAdd || responseChange || responseAllow) {
        await updateCart()
    }
}

const handleOnAddToCart = async (item, quantity) => {
    if (!item) {
        return
    }
    const properties = {}
    Object.keys(item.properties).forEach(key => {
        if (key !== LINE_PROPERTY) {
            properties[key] = item.properties[key]
        } else {
            properties[key] = null
        }
    })
    const sendAddToCart = await addNewItemToCart({
        variant_id: item.id,
        quantity: quantity || 1,
        properties: properties,
    })

    if (sendAddToCart) {
        await updateCart()
    }
}

const changeCartItems = async (items, value = null) => {
    if (!items.length) return false
    const response = await Promise.all(
        await items.map(async item => {
            const properties = {}
            Object.keys(item.properties).forEach(key => {
                if (key !== LINE_PROPERTY) {
                    properties[key] = item.properties[key]
                } else {
                    properties[key] = value
                }
            })
            const response = await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: item.key,
                    properties: properties,
                }),
            })
            return response.ok
        }),
    )
    return response.some(value => value === true)
}

const updateCartItems = async items => {
    if (!items.length) return false
    const formData = { updates: {} }
    items.forEach(item => {
        formData["updates"][item.key] = 1
    })
    try {
        const updateResponse = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        }).then(res => res.json())
        if (updateResponse) {
            return true
        }
        return false
    } catch (e) {
        return false
    }
}

const initCartObserver = () => {
    const cartObserver = new PerformanceObserver(list => {
        list.getEntries().forEach(rawEntry => {
            const entry = rawEntry.toJSON()
            const isValidRequestType = ["xmlhttprequest", "fetch"].includes(entry.initiatorType)
            const regex = /\/cart(\/(?!\.js\b)[^ ]*|$)/
            const isCartChangeRequest = regex.test(entry.name)
            if (isValidRequestType && isCartChangeRequest) {
                checkCart()
            }
        })
    })

    cartObserver.observe({ entryTypes: ["resource"] })
}

const initCheckers = () => {
    const errorMessage =
        document.querySelector("#text-error-capsules-listener").value ||
        "Your can only have 1 of this per capsule"
    ;(function (ns, fetch) {
        ns.fetch = async function () {
            const url = [...arguments].at(0)
            if (
                (url.includes("/cart/change") || url.includes("/cart/update")) &&
                !url.includes("/cart.js")
            ) {
                const rawBody = [...arguments].at(1).body ?? null
                const body = typeof rawBody === "object" ? rawBody : JSON.parse(rawBody)
                if (body) {
                    const cart = await fetch
                        .apply(undefined, [
                            "/cart.js",
                            {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                    Accept: "application/json",
                                },
                            },
                        ])
                        .then(res => res.json())
                    if (body.line && body.quantity > 1) {
                        const item = cart.items.at(Number(body.line) - 1)
                        if (item && item.properties[LINE_PROPERTY]) {
                            const myOptions = {
                                status: 422,
                                statusText: "Error with item",
                            }
                            const body = {
                                errors: errorMessage,
                            }
                            handleOnAddToCart(item, body.quantity)
                            return new Response(JSON.stringify(body), myOptions)
                        }
                    } else if (body.id && body.quantity > 1) {
                        const item = cart.items.find(
                            item => item.id == body.id || item.key == body.id,
                        )
                        if (item && item.properties[LINE_PROPERTY]) {
                            const myOptions = {
                                status: 422,
                                statusText: "Error with item",
                            }
                            const body = {
                                errors: errorMessage,
                            }
                            handleOnAddToCart(item, body.quantity)
                            return new Response(JSON.stringify(body), myOptions)
                        }
                    }
                }
            }
            try {
                return fetch.apply(this, arguments)
            } catch (error) {
                console.error("Fetch failed:", error)
                throw error
            }
        }
    })(window, window.fetch)
}

document.addEventListener("DOMContentLoaded", () => {
    initCheckers()
    checkCart()
    initCartObserver()
})

const updateCart = async () => {
    try {
        const cartDrawer = document.querySelector("cart-drawer-items")
        const cartItems = document.querySelector("cart-items")
        if (cartDrawer) {
            const sections = cartDrawer.getSectionsToRender()
            const parsedState = await fetch(
                `?sections=${sections
                    .map(section => section.section)
                    .filter(section => section !== undefined)
                    .join(",")}`,
            ).then(res => res.json())
            if (parsedState) {
                sections.forEach(section => {
                    const element = document.getElementById(section.id)
                    if (element) {
                        const elementToReplace = element.querySelector(section.selector) || element
                        if (elementToReplace && parsedState[section.section]) {
                            elementToReplace.innerHTML = htmlParse(
                                parsedState[section.section],
                            ).querySelector(section.selector)?.innerHTML
                        }
                    }
                })
            }
        }

        if (cartItems) {
            cartItems.onCartUpdate()
            const mainCartFooter = document.querySelector("#main-cart-footer")
            if (mainCartFooter) {
                fetch("/cart").then(async res => {
                    const rawHtml = await res.text()
                    const rawContent = htmlParse(rawHtml)
                    const newCartFooter = rawContent.querySelector("#main-cart-footer")
                    mainCartFooter.innerHTML = newCartFooter?.innerHTML ?? ""
                })
            }
        }
    } catch (e) {
        console.log("e", e)
    }
}
